import React from 'react';
import ReactPlayer from 'react-player';


const VideoPlayer = ({ videoUrl }) => {
    if (!videoUrl) {
        return <p>Errore nel caricamento del video...</p>;
    }

    return (
        <div style={{ maxWidth: '100%', position: 'relative' }}>
            <ReactPlayer
                url={videoUrl}
                controls
                width="100%"
                height="100%"
                playing={false}
                onContextMenu={(e) => e.preventDefault()}
            />
        </div>
    );
};

export default VideoPlayer;